seedWebApp.controller('IntegrationsCtrl', ['$scope', '$uibModal', '$location', 'IntegrationMonitorService', 'ToastService', '$interval', '$rootScope', 'TranslationService',
    function ($scope, $uibModal, $location, IntegrationMonitorService, ToastService, $interval, $rootScope, TranslationService) {

        $scope.overflowSize = 120;
        $scope.lastRefresh = new Date();
        $scope.loading = false;
        $scope.executing = true;
        $scope.statusFilter = 'Ativas';
        $scope.filterIntegrations = '';
        $scope.translation = TranslationService.getActiveTranslation();
        $rootScope.moduleName = 'Integrações';
        $scope.viewType = 'list';

        $scope.Timers = [
            {
                "UpdateOption": 0,
                "TimerID": 157,
                "TimerName": null,
                "IntegrationID": "0",
                "TimerStatus": null,
                "Hour": 12,
                "Minute": 0,
                "Second": 0,
                "TimerMonday": true,
                "TimerTuesday": true,
                "TimerWednesday": true,
                "TimerThursday": true,
                "TimerFriday": true,
                "TimerSaturday": true,
                "TimerSunday": true,
                "NextDateTime": null,
                "Control": 0,
                "RowState": "Modified",
                "HashedKey": "157",
                "Name": "IntegrationTimer_DCE72B854C33EB8E1E0C044D94354ED7935B95520567DBB377F4517DA4320D4E"
            },
            {
                "UpdateOption": 0,
                "TimerID": 158,
                "TimerName": null,
                "IntegrationID": "0",
                "TimerStatus": null,
                "Hour": 7,
                "Minute": 0,
                "Second": 0,
                "TimerMonday": true,
                "TimerTuesday": true,
                "TimerWednesday": true,
                "TimerThursday": true,
                "TimerFriday": true,
                "TimerSaturday": true,
                "TimerSunday": true,
                "NextDateTime": null,
                "Control": 0,
                "RowState": "Modified",
                "HashedKey": "158",
                "Name": "IntegrationTimer_DCE72B854C33EB8E1E0C044D94354ED7935B95520567DBB377F4517DA4320D4E"
            }
        ];

        $scope.edit = function (id) {
            console.log('IntegrationScopes ' + id);
            $location.path('/Integrations/IntegrationScopes/' + id);
        };

        $scope.editModal = function (item) {
            console.log('editModal');

            var integrationID = '';
            if (item === 'ADD_NEW') {
                integrationID = item;
            } else {
                integrationID = item.IntegrationID;
            }

            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/EditAdminIntegration.html',
                controller: 'EditAdminIntegrationCtrl',
                size: 'lg',
                resolve: {
                    integrationID: function () { return integrationID; }
                }
            });

            modalInstance.result.then(function (action) {
                if (action === 'DELETE') {
                    ToastService.createToast('Integração deletada com sucesso!', '', 8000, 'success');
                }
                else {
                    ToastService.createToast('Integração salva com sucesso!', '', 4000, 'success');
                }
                $scope.reloadListFromActiveTab();
            });
        };       

        $scope.loadListResetCache = function () {
            IntegrationMonitorService.resetCache();
            $scope.loadList();
        };

        $scope.reloadListFromActiveTab = function () {
            $scope.loadListResetCache();
        };

        $scope.loadList = function () {
            $scope.loading = true;
            IntegrationMonitorService.getIntegrationList().then(function (data) {
                $scope.listItems = data.map(function (item) {
                    if (item.IntegrationGroup === null || item.IntegrationGroup === '') {
                        item.IntegrationGroup = '';
                    }

                    var translation = $scope.translation;
                    if (translation) {
                        var translate = translation[item.IntegrationGroup.replace(/\s/g, '')];
                        if (translate) {
                            item.IntegrationGroup = translate;
                        } else {
                            item.IntegrationGroup = item.IntegrationGroup;
                        }
                    }
                    return item;
                });
                $scope.originalItems = $scope.listItems;
                $scope.filter();
                $scope.filterTable();
                $scope.broadcastErrors();
                $scope.loading = false;
            }, function () {
                $scope.loading = false;
            });
        };

        $scope.filter = function () {
            if (!$scope.originalItems) {
                $scope.originalItems = $scope.listItems;
            }

            var items = [];
            var listItems = $scope.originalItems;

            if ($scope.statusFilter === 'Todas') {
                for (var i = 0; i < listItems.length; i++) {
                    items.push(listItems[i]);
                }
            }
            else if ($scope.statusFilter === 'Inativas') {
                for (var j = 0; j < listItems.length; j++) {
                    if (listItems[j].IntegrationStatusID === '0' && listItems[j].IntegrationStatusID !== null) {
                        items.push(listItems[j]);
                    }
                }
            }
            else if ($scope.statusFilter === 'Ativas') {
                for (var k = 0; k < listItems.length; k++) {
                    if (listItems[k].IntegrationStatusID === '1' || listItems[k].IntegrationStatusID === null) {
                        items.push(listItems[k]);
                    }
                }
            }
            $scope.listItems = items;
        };

        $scope.broadcastErrors = function () {
            var logErrors = [];
            for (var i = 0; i < $scope.listItems.length; i++) {
                var item = $scope.listItems[i];
                if (item.RecentErrors && item.RecentErrors.length > 0) {
                    //Adiciona apenas o 1o erro
                    var error = item.RecentErrors[0];
                    logErrors.push(error);
                }
            }

            $rootScope.$broadcast('on_integration_errors', logErrors);
        };

        $scope.loadList();

        $scope.filterTable = function () {
            if ($scope.filterIntegrations) {
                var itemsFromIntegrations = [];
                var itensToProcess = $scope.listItems;

                for (var i = 0; i < itensToProcess.length; i++) {
                    if ((itensToProcess[i].IntegrationID.toUpperCase().indexOf($scope.filterIntegrations.toUpperCase()) !== -1) || (itensToProcess[i].IntegrationName.toUpperCase().indexOf($scope.filterIntegrations.toUpperCase()) !== -1)) {
                        itemsFromIntegrations.push(itensToProcess[i]);
                    }
                }
                return itemsFromIntegrations;
            } else {
                return $scope.listItems;
            }
        };

        $scope.$watch('filterIntegrations', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if ($scope.listItems) {
                }
            }
        }, true);

        $interval(function () {
            if ($scope.isMonitoring()) {
                console.log('Recarregando integracoes...');
                $scope.loadListResetCache();
            }
        }, 1800 * 1000, 0, true);

        $scope.isMonitoring = function () {
            return IntegrationMonitorService.isMonitoring;
        };

        $scope.toggleMonitoring = function () {
            IntegrationMonitorService.toggleMonitoring();
        };    
    }
]);